import React, { useEffect, useContext } from 'react';
import ReactDOM from 'react-dom';
import ComponentProvider, { ComponentContext } from './ComponentProvider';
import { BundleStep, BundleSummary } from './parts'


const BundleBuilder = () => {
  const { stepsState } = useContext(ComponentContext);
  const [steps] = stepsState

  if (!steps) return null

  return (
    <>
      <BundleSummary />
      {steps.map((s, idx) => <BundleStep key={`step-${idx}`} step={s} />)}
    </>
  )
}

const BundleBuilderMain = (props) => {

  return (
    <ComponentProvider {...props}>
      <BundleBuilder {...props} />
    </ComponentProvider>
  )
}


if (!customElements.get('bundle-builder')) {
  customElements.define(
    'bundle-builder',
    class BundleBuilderClass extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        const props = Object.values(this.attributes).map((attribute) => [attribute.name, attribute.value]);

        const element = <BundleBuilderMain ctx={window.theme_app} el={this} {...Object.fromEntries(props)} />;
        ReactDOM.render(element, this);
      }
    }
  );
}
